module.exports = __webpack_public_path__ + "img/cert32.c7a395c8.png";